export default "__VITE_ASSET__c2d3f345__"